'use strict';

const { getDependencyClass } = require('../../lib/dependencies.js');
const { quoteGrid } = require('./partials/quoteGrid.js');
const { optionExtraQuoteGrid } = require('./partials/optionExtraQuoteGrid.js');
const { loadQuoteMediaTool } = require('../../lib/quoteMediaUtil');

getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixQuoteMediaTickerChart extends pageClass.PhoenixElement {
        connectedCallback() {
            const symbol = this.config?.symbol || '';
            if (!symbol) {
                return;
            }

            super.connectedCallback();
            this._render(symbol);
            const qModToolElement = this.querySelector('#m-quote-media-ticker-chart--qmod');
            qModToolElement?.addEventListener('qmod-after-template-bind', function () {
                const quoteGridElement = this.querySelector('#m-quote-media-ticker-chart--quote-grid');

                if (!quoteGridElement) {
                    return;
                }

                qModToolElement.classList.replace('qtool-hold', 'qtool');
                quoteGridElement.style?.removeProperty('display');
            });
            loadQuoteMediaTool(this, 'm-quote-media-ticker-chart--qmod');
        }

        _marketHoursTemplate() {
            return `
                <div class="qmod-mkt-hours">
                    <div class="qmod-mkt-top">
                        <span class="qmod-last" rv-if="data.datatype |= 'index'">
                            {data.pricedata.last | asQHLast tLang}
                        </span>
                        <span class="qmod-last" rv-unless="data.datatype |= 'index'">
                            {data.pricedata.last | asQHLast tLang}
                        </span>
                        <span class="qmod-change" rv-qmodchange="data.pricedata.change">
                            <span class="st-changepercent" rv-qmodchange="data.pricedata.change">
                                <span class="qmod-change-icon fa"
                                    rv-qmodchangeicon="data.pricedata.change"
                                    aria-hidden="true"
                                >
                                </span>
                                <span>
                                    {data.pricedata.changepercent | numeraljs '0.00' | postFix '%' tLang}
                                </span>
                            </span>
                            <span>{data.pricedata.change | asQHLast tLang }</span>
                            <span class="today" rv-unless="data.afterhours.last|='N/A'">Today</span>
                        </span>
                        <span class="qmod-reghalt" rv-if="data.status">
                            <a class="qmod-tooltip"
                                rv-if="data.status.regsho"
                                rv-title="data.status.regsho | asRegsho"
                                rv-on-mouseenter="data.qmtooltip"
                            >
                                {data.status.regsho}
                            </a>
                            <a class="qmod-tooltip"
                                rv-if="data.status.halt"
                                rv-title="data.status.halt.code | asHaltCode"
                                rv-on-mouseenter="data.qmtooltip"
                            >
                                {data.status.halt.code}
                            </a>
                        </span>
                    </div>
                    <div class="qmod-mkt-btm">
                        <span class="qmod-datetime" rv-if="data.pricedata.lasttradedatetime">
                            <span rv-hide="data.entitlement | or_comma_list 'PD,EOD,PW'">
                                <span rv-unless="data.afterhours.last|='N/A'"
                                    rv-show="data.datatype | or 'etf' 'equity'"
                                >
                                    Closed: &nbsp;
                                </span>
                                <span class="qmod-datetime-date"
                                    rv-html="data.pricedata.lasttradedatetime | momentjs 'true' 'LLL' tLang"
                                >
                                </span>
                                <span class="qmod-datetimezone">{data.tz | asTimezone tLang}</span>
                            </span>
                            <span rv-show="data.entitlement | or_comma_list 'PD,EOD,PW'">
                                <span rv-html="data.pricedata.lasttradedatetime | momentjs 'true' 'LL' tLang">
                                </span>
                            </span>
                        </span>
                        <span class="qmod-datetime" rv-unless="data.pricedata.lasttradedatetime">
                            <span class="qmod-datetime-date"
                                rv-show="data.datetime"
                                rv-html="data.datetime | momentjs 'true' 'LL' tLang"
                            >
                            </span>
                        </span>
                        <span class="st-qmod-item" rv-if="data.key.currency">
                            <span rv-html="data.key.currency"></span>
                        </span>
                        <span class="st-qmod-item" rv-if="data.key.exchange">
                            <span rv-html="data.key.exchange"></span>
                        </span>
                        <span class="st-qmod-item">Disclaimer</span>
                    </div>
                </div>
            `;
        }

        // This template should display only in active hours
        _activeHoursTemplate() {
            return `
                <div rv-if="data.afterhours.last|='N/A'">
                    <div class='pure-u-0 pure-u-lg-2-24'>
                    </div>
                    <div class='pure-u-0 pure-u-md-8-24 pure-u-lg-8-24'>
                    </div>
                </div>
            `;
        }

        // This template should display only in after hours
        _afterHoursTemplate() {
            const moonSvgPath = 'M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z';
            return `
                <div rv-unless="data.afterhours.last|='N/A'">
                    <div class="pure-u-1 pure-u-md-11-24 pure-u-lg-14-24 m-quote-media-ticker-chart--widget"
                        rv-show="data.datatype | or 'etf' 'equity'"
                    >
                        <div class="qmod-after-hours" rv-show="data.datatype | or 'etf' 'equity'">
                            <span class="flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg"
                                    class="icon-moon"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path d="${moonSvgPath}" />
                                </svg>
                                After Hours
                            </span>
                            <span class="qmod-afh">
                                <span class="qmod-last"
                                    rv-html="data.afterhours.last | asQHLast tLang"
                                >
                                </span>
                                <span class="qmod-change" rv-qmodchange="data.afterhours.change">
                                    <span class="st-changepercent" rv-qmodchange="data.afterhours.change">
                                        <span class="qmod-change-icon fa"
                                            rv-qmodchangeicon="data.afterhours.change"
                                            aria-hidden="true"
                                        >
                                        </span>
                                        <span>{
                                            data.afterhours.changepercent |
                                            numeraljs '0.00' |
                                            postFix '%' tLang
                                        }</span>
                                    </span>
                                    <span>{data.afterhours.change | asQHLast tLang }</span>
                                </span>
                            </span>
                            <span class="qmod-ah-bottom">
                                <span class="qmod-volume" rv-if="data.afterhours.sharevolume">
                                    <span class="qmod-sm-hide">
                                        Volume: {data.afterhours.sharevolume | numeraljs '0,0' 'N/A' tLang}
                                    </span>
                                </span>
                                <span class="st-qmod-item" rv-if="data.key.currency">
                                    <span rv-html="data.key.currency"></span>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            `;
        }

        _chartTemplate() {
            return `
                <div class="qmod-chart">
                    <div class="qmod-chart-plot">
                        <div class="qmod-view-as-table" rv-show="data.a2accessibility">
                            <span class="qmod-tabeview">
                                <a class="qmod-as-table" href="#" rv-on-click="data.toggleview">
                                    {tplLang.as_table| toLang tLang}
                                </a>
                                <a class="qmod-as-chart"
                                    style="display: none;"
                                    href="#"
                                    rv-on-click="data.toggleview"
                                >
                                    {tplLang.as_chart| toLang tLang}
                                </a>
                            </span>
                        </div>
                        <img class="qmod-tab-img m-quote-media-ticker-chart--img" rv-src="data.qmURL" />
                        <div class="qmod-table-plot" style="display: none;">
                            <table class="qmod-table qmod-chart-table">
                                <thead>
                                    <tr>
                                        <th class="qmod-textl">{tplLang.date| toLang tLang}</th>
                                        <th class="qmod-textr">{tplLang.open| toLang tLang}</th>
                                        <th class="qmod-textr">{tplLang.high| toLang tLang}</th>
                                        <th class="qmod-textr">{tplLang.low| toLang tLang}</th>
                                        <th class="qmod-textr">{tplLang.close| toLang tLang}</th>
                                    </tr>
                                </thead>
                                <tbody class="qmod-chart-tbody"></tbody>
                            </table>
                            <span class="load-more" rv-hide="data.hidemore">
                                <a class="load-more-chart" rv-on-click="data.loadMoreData">
                                    {tplLang.more| toLang tLang}
                                </a>
                            </span>
                        </div>
                    </div>
                    <ul class="qmod-button-group m-quote-media-ticker-chart--buttons"
                        rv-unless="data.key.exchange | = 'NGX'"
                    >
                        <li rv-unless="data.entitlement | or 'EOD' 'PD'">
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | or '1d' '1j'"
                                tabindex="0"
                            >
                                {tplLang.1d| toLang tLang}
                            </button>
                        </li>
                        <li>
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | or '5d' '5j'"
                                tabindex="0"
                            >
                                {tplLang.5d| toLang tLang}
                            </button>
                        </li>
                        <li>
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | = '1m'"
                                tabindex="0"
                            >
                                {tplLang.1m| toLang tLang}
                            </button>
                        </li>
                        <li rv-unless="data.datatype | = 'equity option'">
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | = '3m'"
                                tabindex="0"
                            >
                                {tplLang.3m| toLang tLang}
                            </button>
                        </li>
                        <li rv-unless="data.datatype | = 'equity option'">
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | = '6m'"
                                tabindex="0"
                            >
                                {tplLang.6m| toLang tLang}
                            </button>
                        </li>
                        <li rv-unless="data.datatype | = 'equity option'">
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | or '1y' '1a'"
                                tabindex="0"
                            >
                                {tplLang.1y| toLang tLang}
                            </button>
                        </li>
                        <li rv-unless="data.datatype | = 'equity option'">
                            <button class="qmod-btn"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | or '5y' '5a'"
                                tabindex="0"
                            >
                                {tplLang.5y| toLang tLang}
                            </button>
                        </li>
                        <li rv-if="scope.tenYearChart">
                            <button class="qmod-btn"
                                rv-unless="data.datatype | = 'equity option'"
                                rv-on-click="data.changeChart"
                                rv-class-qmod-btn-active="data.chscale | or '10y' '10a'"
                                tabindex="0"
                            >
                                {tplLang.10y| toLang tLang}
                            </button>
                        </li>
                    </ul>
                </div>
            `;
        }

        _futuresTableTemplate() {
            return `
                <div class="pure-u-1-1 qmod-futures-table-con">
                    <table class="qmod-table qmod-table-small qmod-futures-table responsive nowrap no-footer"
                        width="100%"
                    >
                        <thead>
                            <tr>
                                <th class="qmod-control qmod-th-0"></th>
                                <th class="qmod-textl qmod-th-1">{tplLang.delivery| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-2">{tplLang.symbol| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-3">{tplLang.expirydate| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-4">{tplLang.last| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-5">{tplLang.change| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-6">{tplLang.changepct| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-7">{tplLang.open| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-8">{tplLang.high| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-12">{tplLang.low| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-9">{tplLang.settle| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-10">{tplLang.openint| toLang tLang}</th>
                                <th class="qmod-textr qmod-th-11">{tplLang.vol| toLang tLang}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="qmod-table-row"
                                rv-each-future="data.futures"
                                rv-on-click="data.clickRow"
                            >
                                <td class="qmod-td-0 qmod-control"></td>
                                <td class="qmod-textl qmod-td-1">
                                    {future.contract.deliverydate | date 'MMM YYYY'}
                                </td>
                                <td class="qmod-textr qmod-td-2">{future.symbolstring}</td>
                                <td class="qmod-textr qmod-td-3">
                                    {future.contract.expirydate | date 'MMM DD, YYYY'}
                                </td>
                                <td class="qmod-textr qmod-td-4">{future.pricedata.last| asQHLast}</td>
                                <td class="qmod-textr qmod-td-5">{future.pricedata.change| asQHLast}</td>
                                <td class="qmod-textr qmod-td-6">
                                    {future.pricedata.changepercent| asQHLast}
                                </td>
                                <td class="qmod-textr qmod-td-7">{future.pricedata.open| asQHLast}</td>
                                <td class="qmod-textr qmod-td-8">{future.pricedata.high| asQHLast}</td>
                                <td class="qmod-textr qmod-td-9">{future.pricedata.low| asQHLast}</td>
                                <td class="qmod-textr qmod-td-10">{future.contract.settle| asQHLast}</td>
                                <td class="qmod-textr qmod-td-11">
                                    {future.contract.openint| numeraljs '0,0.[00]' '0'}
                                </td>
                                <td class="qmod-textr qmod-td-12">
                                    {future.contract.volume| numeraljs '0,0.[00]a' '0'}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            `;
        }

        _customTemplate() {
            const invalidTemplate =
                '{tplLang.notentitled| toLang tLang} {tplLang.for| toLang tLang} {data.symbolstring}';

            return `
                <div class="qmod-ui-tool qmod-detailedquote">
                    <div class="qmod-quotehead" rv-unless="data.entitlement | = 'NA'">
                        <div class="qmod-block-wrapper" rv-addclass='tLang | preFix "qmod-lang-"'>
                            <div class="qmod-invalid" rv-unless="data | isEntitled">
                                ${invalidTemplate}
                            </div>
                            <div class="qmod-invalid" rv-unless="data | isValidSymbol">
                                {tplLang.invalidsymbol| toLang tLang}: {data.symbolstring}
                            </div>
                            <div class="pure-g" rv-unless="data.entitlement | = 'NA'">
                                <div class="pure-u-1 pure-u-md-2-5" rv-class-pure-u-md-1-2="data.qhShowRight">
                                    <div class="qmod-head-left">
                                        ${this._marketHoursTemplate()}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-md-3-5">
                                    ${this._activeHoursTemplate()}
                                    ${this._afterHoursTemplate()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="qmod-block-wrapper">
                        <div class="pure-g m-quote-media-ticker-chart--data-graph"
                            rv-if="data | isValidSymbol"
                        >
                            <div class="pure-u-1 pure-u-md-3-5" rv-if="data | isEntitled">
                                ${this._chartTemplate()}
                            </div>
                            <div class="pure-u-1 pure-u-md-2-5" rv-if="data | isEntitled">
                                ${quoteGrid()}
                            </div>
                            <div class="pure-u-1" rv-if="data.datatype | = 'equity option'">
                                ${optionExtraQuoteGrid()}
                            </div>
                            <div class="pure-u-1" rv-if="data.datatype | = 'future'">
                                ${this._futuresTableTemplate()}
                            </div>
                        </div>
                        <div class="pure-g" rv-unless="data | isValidSymbol">
                            <div class="pure-u-1 qmod-textc" rv-if="data.datatype | = 'n/a'">
                                <div class="qmod-label">
                                    {tplLang.invalidsymbol| toLang tLang}: {data.symbolstring}
                                </div>
                            </div>
                        </div>
                        <div class="pure-g" rv-unless="data | isEntitled">
                            <div class="pure-u-1 qmod-textc" rv-unless="data | isEntitled">
                                <div class="qmod-invalid">${invalidTemplate}</div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }

        _render(symbol) {
            const params = {
                chscale: '1d',
                chwid: 560,
                chhig: 350,
                chln: '026289',
                chfill: '026289',
                chfill2: 'c2e7f5',
                chxyc: '8d8d8d',
                chbdr: 'ffffff',
                chton: 'off',
                chdon: 'off',
                chcon: 'off',
                chfrmon: 'off',
                chgrdon: 'off',
                symbol: symbol,
            };

            this.innerHTML = `
                <div
                    id='m-quote-media-ticker-chart--qmod'
                    data-qmod-tool="detailedquotetabchart"
                    data-qmod-params='${JSON.stringify(params)}'
                    class="qtool-hold"
                >
                    <script type="text/template">${this._customTemplate()}</script>
                </div>
            `;
        }
    }

    window.customElements.define('phoenix-quote-media-ticker-chart', PhoenixQuoteMediaTickerChart);
});
